import { portImg1, portImg2,portImg3, portImg4,portImg5, portImg6,portImg7, portImg8,portImg9, portImg10,portImg11, portImg12,portImg13,  } from '../../img/portfolio';
const portafolios = [
    {
        id: 1,
        caption: '',
        image: portImg1,
    },
    {
        id: 2,
        caption: '',
        image: portImg2,
    },
    {
        id: 3,
        caption: 'DISEÑO PORTARROLLOS',
        image: portImg3,
    },
    {
        id: 4,
        caption: 'DISENO PRENSAMOTOR',
        image: portImg4,
    },
    {
        id: 5,
        caption: 'IMPRESION 3D',
        image: portImg5,
    },
    {
        id: 6,
        caption: 'IMPRESIONG 3D',
        image: portImg6,
    },
    {
        id: 7,
        caption: 'MAQUINADO PORTARROLLOS',
        image: portImg7,
    },
    {
        id: 8,
        caption: 'MAQUINADO PRENSAS',
        image: portImg8,
    },
    {
        id: 9,
        caption: 'SOLDADURA BRACKETS',
        image: portImg9,
    },
    {
        id: 10,
        caption: 'SOLDADURA MUEBLE',
        image: portImg10,
    },
    {
        id: 11,
        caption: 'SOLUCIONES DISPENSADOR',
        image: portImg11,
    },
    {
        id: 12,
        caption: 'SOLUCIONES CARRITO',
        image: portImg12,
    },
    {
        id: 13,
        caption: 'SOLUCIONES GUARDAS',
        image: portImg13,
    },
];

export {portafolios}